import { diagnosticLog } from './diagnosticLogger';

/**
 * MST-6102: clearQueue's setQueue([],0)/setCurrentTrack(null) transition fires
 * subscribers synchronously. A subscriber doing O(library) work on the main
 * thread can block the WKWebView JS thread for tens of seconds. This threshold
 * flags that transition so a future diag capture can bracket the exact subscriber.
 */
export const CLEAR_QUEUE_TRANSITION_WARN_MS = 100;

export function logClearQueueTransitionIfSlow(transitionStartMs: number, preClearQueueLength: number): void {
  const durationMs = performance.now() - transitionStartMs;
  if (durationMs > CLEAR_QUEUE_TRANSITION_WARN_MS) {
    diagnosticLog('warn', 'playback', 'clear_queue_transition_slow', {
      durationMs: Math.round(durationMs),
      preClearQueueLength,
    });
  }
}
